import React, { Component } from "react";
import { withTranslation } from "react-i18next";
import "./app-container.scss";
class AppContainer extends Component {
  render() {
    return <div className="bg-image">{this.props.children}</div>;
  }
}
export default withTranslation()(AppContainer);
